export const themes = {
    dark: "dark",
    light: "light",
};